import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import Form from '../../../../antd/form/Form/Form.jsx';
import FormRangeDatePicker from '../../../../antd/form/FormRangeDatePicker/FormRangeDatePicker.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import { required } from '../../../../antd/form/FormValidation.js';

const IngProjectsSettingsForm = ({ onSubmit, initials, form, disabled }) => {
  const { t } = useTranslation();

  const handleSubmit = (values) => {
    const cleanedValues = {
      date_project_modification_from: values.projectModificationRange?.[0]?.format('YYYY-MM-DD') || null,
      date_project_modification_to: values.projectModificationRange?.[1]?.format('YYYY-MM-DD') || null,
      date_student_application_from: values.studentApplicationRange?.[0]?.format('YYYY-MM-DD') || null,
      date_student_application_to: values.studentApplicationRange?.[1]?.format('YYYY-MM-DD') || null,
      date_panel_story_from: values.panelStoryRange?.[0]?.format('YYYY-MM-DD') || null,
      date_panel_story_to: values.panelStoryRange?.[1]?.format('YYYY-MM-DD') || null,
    };

    onSubmit(cleanedValues);
  };

  return (
    <Form form={form} onFinish={handleSubmit} initialValues={initials}>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <FormRangeDatePicker
            label={t('Obdobie manažovania projektov')}
            name="projectModificationRange"
            rules={[required(t)]}
          />
        </Col>
        <Col xs={24} md={12}>
          <FormRangeDatePicker
            label={t('Obdobie prihlasovania študentov')}
            name="studentApplicationRange"
            rules={[required(t)]}
          />
        </Col>
        <Col xs={24} md={12}>
          <FormRangeDatePicker
            label={t('Obdobie Panel Story')}
            name="panelStoryRange"
            disabled={disabled}
          />
        </Col>
      </Row>

      <FormButtonsContainer>
        <FormButton submitOnClick={true} submitKey={'ip-settings'}>
          {t('Uložiť')}
        </FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

export default IngProjectsSettingsForm;
